import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-zinc-950 py-12 sm:py-14" aria-labelledby="faq-heading" data-id="element-45" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-46" data-mp="1gj3njwjhxbrj">
        <div className="text-center" data-id="element-47" data-mp="1gjvid559r5gr">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-48" data-mp="249g4ty0mskus">Prima di decidere</p>
          <h2 id="faq-heading" className="mt-4 font-serif text-[2rem] font-bold leading-[1.1] text-stone-100 sm:text-4xl" data-id="element-49" data-mp="289q7p1t4mv5f">
            Domande frequenti
          </h2>
        </div>

        <ul className="mt-10 space-y-2.5" data-id="element-50" data-mp="1zhy0czzeg252">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-zinc-900 transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500/45' : 'border-zinc-800'}`} data-id="element-51" data-mp="2n6hazm5x8r0b" data-mpi={index}>
                <h3 data-id="element-52" data-mp="14wbxew7ad1yc">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-500" data-id="element-53" data-mp="14vtr16qwt7cp">
                    <span className="font-serif text-lg font-bold leading-snug text-stone-100 sm:text-xl" data-id="element-54" data-mp="1oj1b9l6qh6yp">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-yellow-500 bg-yellow-500 text-zinc-950' : 'border-yellow-500/35 bg-yellow-500/10 text-yellow-500'}`} aria-hidden="true" data-id="element-55" data-mp="1jmj64k7hr6lu">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-56" data-mp="3813puve46i8" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-57" data-mp="1yb7lwzrcvzb5">
                  <div className="overflow-hidden" data-id="element-58" data-mp="289dm9cxikxdw">
                    <p className="px-6 pb-6 font-sans text-[0.92rem] leading-relaxed text-stone-400" data-id="element-59" data-mp="2c9xhuc2fvsxx">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}